import { compose } from 'redux';
import TableHeaderCell from './TableHeaderCell';
import withDrag from './withDrag';
import withSort from './withSort';

export const DraggableTableCell = withDrag(TableHeaderCell);
export const SortableTableCell = withSort(TableHeaderCell);
export const EnhancedTableCell = compose(withDrag, withSort)(TableHeaderCell);
